import { ValidatorFn } from '@angular/forms';
import { FloorsElevators } from '../../stacking-plan.model';
import { Settings } from '../settings/settings.model';
import { FloorSizeStrategy } from './new-export-to-excel.service';
import { StackPlanViewModel } from '../../../state/sp-view-state.model';

export const enum FileType {
  Excel = 'Excel',
  Powerpoint = 'Powerpoint',
  PDF = 'PDF',
}

export interface ExportTemplate {
  expiry: boolean;
  industry: boolean;
  agency: boolean;
  usage: boolean;
  occupier: boolean;
  none: boolean;
}

export type ExportSettings = Settings & {
  exportTemplate: ExportTemplate;
  maxFloorStrategy: FloorSizeStrategy;
  fileType?: FileType;
};

export enum FormType {
  GROUP = 'group',
  CONTROL = 'control',
}

export interface ExportInputData {
  exportSettings: ExportSettings;
  floorElevatorData: FloorsElevators;
  localeId: number;
}

export interface ExportConfig {
  label: string;
  key: string;
  options?: ExportConfig[];
  validators?: ValidatorFn[];
  formType?: FormType;
  icon?: string;
  tooltip?: string;
}

export enum StackingPlanExportTypes {
  SPExcel = 'SP_Excel',
  PVPDF = 'PV_PDF',
  PVExcel = 'PV_Excel',
}

export const SP_REPORT_NAME_BY_TYPES = Object.freeze({
  [StackingPlanExportTypes.SPExcel]: 'Stacking Plan',
  [StackingPlanExportTypes.PVPDF]: 'Side by Side View PDF',
  [StackingPlanExportTypes.PVExcel]: 'Side by Side View Excel',
});

export interface ExportExecutableParams {
  exportOptions: Record<string, any>;
  propertyId: number;
  fileType: FileType;
  exportType: StackingPlanExportTypes;
  dialogOptions: Record<string, any> & { fileType: string };
  propertyData: Record<string, any>;
  viewState?: StackPlanViewModel;
}
